<template>
  <div>
    <div id="qywxQrcode"></div>
  </div>
</template>

<script>
import * as ww from '@wecom/jssdk'

export default {
  name: 'qrcode',
  data() {
    return {
      wwLogin: null,
    }
  },
  methods: {},
  computed: {
    config() {
      return Wiz.GetModuleConfig('auth-login')
    }
  },
  created() {},
  mounted() {
    const that = this
    this.wwLogin = ww.createWWLoginPanel({
      el: '#qywxQrcode',
      params: {
        login_type: 'CorpApp',
        appid: this.config.appid,
        agentid: this.config.agentid,
        redirect_uri: this.config.redirect_uri,
        state: 'state',
        redirect_type: 'callback'
      },
      onCheckWeComLogin({ isWeComLogin }) {
        // console.log(isWeComLogin)
      },
      onLoginSuccess({ code }) {
        // console.log(code)
        // 传值获取登录信息
        that.$emit('qywxLogin', code)
      },
      onLoginFail(err) {
        // console.log(err)
      }
    })
  },
  destroyed() {
    this.wwLogin.unmount()
  }
}
</script>

<style lang="scss">
#qywxQrcode {
  iframe {
    width: 400px!important;
  }
}
</style>
